/**
 * @generated SignedSource<<0e187f0f7e2d33c53ab1ccd461d3f7a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteEditStats_seoRoute$data = {
  readonly stats: ReadonlyArray<{
    readonly destinationViews: number;
    readonly sourceViews: number;
    readonly week: string;
  }>;
  readonly " $fragmentType": "SeoRouteEditStats_seoRoute";
};
export type SeoRouteEditStats_seoRoute$key = {
  readonly " $data"?: SeoRouteEditStats_seoRoute$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeoRouteEditStats_seoRoute">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoRouteEditStats_seoRoute",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SeoRouteStat",
      "kind": "LinkedField",
      "name": "stats",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "week",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceViews",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "destinationViews",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SeoRoute",
  "abstractKey": null
};

(node as any).hash = "de8b636f1ccd3738a729897f36b162ce";

export default node;
